import * as Yup from "yup";
import { pattern } from "./ValidationPattern.const";
import dayjs from "dayjs";

export const createPackageValidationSchema = Yup.object({
  packageName: Yup.string()
    .min(5, "Package name must be at least 5 characters long")
    .max(30, "Package name must not exceed 30 characters")
    .required("Package name is required"),
  description: Yup.string()
    .min(5, "Description must be at least 5 characters long")
    .max(200, "Description must not exceed 200 characters")
    .required("Description is required"),
  height: Yup.string().test(
    "equalTo",
    "Please enter a height between 0.5 to 99999.99 inches.",
    (value) => !(Number(value) === 0)
  ),
  width: Yup.string().test(
    "equalTo",
    "Please enter a width between 0.5 to 99999.99 inches.",
    (value) => !(Number(value) === 0)
  ),
  depth: Yup.string().test(
    "equalTo",
    "Please enter a depth between 0.5 to 99999.99 inches.",
    (value) => !(Number(value) === 0)
  ),
  weight: Yup.string().test(
    "equalTo",
    "Please enter a weight between 0.5 to 99999.99 lbs.",
    (value) => !(Number(value) === 0)
  ),
  expiryDate: Yup.date()
    .required("Expiry date is required")
    .typeError("Enter valid details")
    .min(
      dayjs(new Date()).subtract(1, "day"),
      "Expiry date must be greater than or equal to today"
    ),
  pickupFullName: Yup.string()
    .min(3, "Name must be at least 3 characters long")
    .max(50, "Name must not exceed 50 characters")
    .required("Full name is required"),
  pickupPhoneNumber: Yup.string()
    .min(10, "Phone number must be exactly 10 digits long.")
    .max(10, "Phone number must be exactly 10 digits long.")
    .required("Phone Number is required"),
  pickupAddress: Yup.string()
    .matches(pattern.AlphaNumericForAddress, "Enter valid details")
    .min(2, "Address must be at least 2 characters long")
    .max(100, "Address must not exceed 100 characters")
    .required("Address is required"),
  pickupCity: Yup.string().required("city is required"),
  pickupState: Yup.string().required("state is required"),
  pickupZipcode: Yup.string().required("zipcode is required"),
  deliveryFullName: Yup.string()
    .min(3, "Name must be at least 3 characters long")
    .max(50, "Name must not exceed 50 characters")
    .required("Full name is required"),
  deliveryPhoneNumber: Yup.string()
    .min(10, "Phone number must be exactly 10 digits long.")
    .max(10, "Phone number must be exactly 10 digits long.")
    .required("Phone Number is required"),
  deliveryAddress: Yup.string()
    .matches(pattern.AlphaNumericForAddress, "Enter valid details")
    .min(2, "Address must be at least 2 characters long")
    .max(100, "Address must not exceed 100 characters")
    .required("Address is required"),
  deliveryCity: Yup.string().required("city is required"),
  deliveryState: Yup.string().required("state is required"),
  deliveryZipcode: Yup.string().required("zipcode is required"),
  specialInstructions: Yup.string().max(
    200,
    "Special Instructions must not exceed 200 characters"
  ),
});
